<template>
  <collapse-card name="capabilities">
    <template v-slot:title>Start of Placement Capability Data</template>

    <template v-for="group in groupedCapabilities">
      <h4 :key="`heading-${group.id}`">{{ group.name }}</h4>

      <div class="row" :key="`row-${group.id}`">
        <div class="col-6 col-xl-3" v-for="capability in group.capabilities" :key="`capability-${capability.id}`">
          <p class="text-truncate" :title="`${capability.name} ${capability.focus ? '(Focus)' : ''}`">
            <strong>{{ capability.name }} <span v-if="capability.focus">(Focus)</span></strong>
            <br>{{ capability.result | capability(strengthText) | nullable }}
          </p>
        </div>
      </div>
    </template>
  </collapse-card>
</template>

<script>
import { placementComputed } from 'vx/helpers'
import CollapseCard from 'components/CollapseCard'

export default {
  components: {
    CollapseCard
  },

  computed: {
    ...placementComputed
  }
}
</script>
